import React from "react";
import { Button} from '@blueprint/ui';
import { NavLink } from "react-router-dom";

import { useProjectListWithTxn } from "../../api/project";
import { Loader } from "../../common/components/core";
import { useSelector } from "../../redux/hooks";
import { currentRolesSelector } from "../../redux/slices/auth/selectors";
import { ProjectStateWithTxn } from "../../types/project";
import { PageTitle } from "../../types/pageTitle";
import { isUserFinanceDepartment } from "../../utils/role";

import ProjectAccountList from "./components/ProjectAccountList";

const CollectionView = (): JSX.Element => {
    document.title = PageTitle.CollectionView;
    const { data: projects, isValidating: isProjectLoading } =
        useProjectListWithTxn();

    return (
        <Loader isLoading={isProjectLoading}>
            {projects && (
                <PureCollectionView
                    projects={projects}
                />
            )}
        </Loader>
    );
};

type PureCollectionViewProps = {
    projects: ProjectStateWithTxn[];
};

export const PureCollectionView = ({
    projects,
}: PureCollectionViewProps): JSX.Element => {
    const currentRoles = useSelector(currentRolesSelector);

    return (
        <>
            <h1 className="mb-5">Collection</h1>

            <div className="d-flex align-items-center my-3">
                <h2 className="flex-grow-1 mb-0">Projects</h2>
                {projects.length > 0 &&
                    isUserFinanceDepartment(currentRoles) && (
                        <NavLink to="/collection/manage-accounts">
                            <Button variant="light.primary" className="ms-4">
                                Manage Project
                            </Button>
                        </NavLink>
                    )}
            </div>
            <ProjectAccountList projects={projects} />
        </>
    );
};

export default CollectionView;
